export interface Suggest {
  readonly label: string
  readonly placeId?: string
  readonly description?: string
  readonly gmaps?: google.maps.places.PlaceResult | google.maps.GeocoderResult
  readonly location?: {
    lat: number
    lng: number
  }
  readonly matchedSubstrings?: {
    offset: number
    length: number
  }
  readonly structuredFormatting?: google.maps.places.AutocompleteStructuredFormatting
  readonly loqateType?: LoqateItemType
  readonly loqateId?: string
  readonly loqateAddress?: LoqateAddress
}

export interface SuggestOptions {
  bounds?: google.maps.LatLngBounds | google.maps.LatLngBoundsLiteral
  country?: string | string[]
  location?: google.maps.LatLng | google.maps.LatLngLiteral
  radius?: number
  types?: string[]
  componentRestrictions?: { country: string | string[] }
}

export type AddressObject = {
  street_number: string
  postal_code: string
  street: string
  region: string
  city: string
  country: string
  full_country_name: string
  subpremise?: string
  premise?: string
  company_name?: string
  state?: string
  sub_building?: string | null
  loqate_place_id?: string | null
  building_name?: string
  line1?: string
  line2?: string
  label?: string
}

export const LOQATE_ITEM_TYPES = {
  address: 'Address',
  postCode: 'Postcode',
  residential: 'Residential',
  street: 'Street',
  building: 'Building',
  buildingName: 'BuildingName'
} as const

export type LoqateItemType =
  (typeof LOQATE_ITEM_TYPES)[keyof typeof LOQATE_ITEM_TYPES]

export interface LoqateItem {
  Id: string
  Description: string
  Type: LoqateItemType
  Text: string
  Highlight: string
}

export interface LoqateFindAddressResponse {
  Items: LoqateItem[]
}

export interface LoqateFindAddressRequest {
  Text: string
  Countries?: string
  Limit?: number
  Language?: string
  Container?: string
}

export interface LoqateAddress {
  AdminAreaCode: string
  AdminAreaName: string
  Barcode: string
  Block: string
  BuildingName: string
  BuildingNumber: string
  City: string
  Company: string
  CountryIso2: string
  CountryIso3: string
  CountryIsoNumber: number
  CountryName: string
  DataLevel: string
  Department: string
  District: string
  DomesticId: string
  Field1: string
  Field2: string
  Field3: string
  Field4: string
  Field5: string
  Field6: string
  Field7: string
  Field8: string
  Field9: string
  Field10: string
  Field11: string
  Field12: string
  Field13: string
  Field14: string
  Field15: string
  Field16: string
  Field17: string
  Field18: string
  Field19: string
  Field20: string
  Id: string
  Label: string
  Language: string
  LanguageAlternatives: string
  Line1: string
  Line2: string
  Line3: string
  Line4: string
  Line5: string
  Neighbourhood: string
  POBoxNumber: string
  PostalCode: string
  Province: string
  ProvinceCode: string
  ProvinceName: string
  SecondaryStreet: string
  SortingNumber1: string
  SortingNumber2: string
  Street: string
  SubBuilding: string
  Type: string
}

export interface LoqateRetrieveRequest {
  Id: string
  Field1Format?: string
  Field2Format?: string
}

export interface LoqateRetrieveResponse {
  Items: LoqateAddress[]
}
